import React from 'react'
import Details from './PlanDetails'

const PlanDetails = (props) => (
  <Details {...props} />
)

export default PlanDetails



// WEBPACK FOOTER //
// src/components/PlanDetails/index.js